import { biliBridge } from '@bilibili/js-bridge'
import axios from 'axios'
import createError from 'axios/lib/core/createError'
import pkg from '../../package'
import { isFunction, debugFn } from './../utils'
import { getTimeout, getBaseURL } from './../process'
import { DEF_CONST, BRIDGE_METHOD } from './../enum'
import { appendRequestData, convertFormData, convertRequestURL } from './../shim'

const webInstance = (option, runtime) => {
  option = option || {}

  const instance = axios.create()

  instance.interceptors.request.use(
    (config) => {
      config._runtime = runtime
      config._version = pkg.version
      debugFn(option, config)
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  instance.interceptors.response.use((response) => {
    let res = response.data
    if (isFunction(option.onSuccess)) {
      res =
        option.onSuccess({
          url: response.config.url,
          method: response.config.method,
          config: {
            headers: response.config.headers
          },
          data: res
        }) || res
    }
    return res
  })

  return async function (url, data, config) {
    const requestData = await appendRequestData(data, DEF_CONST.method.POST, option, config, runtime)

    return instance({
      url,
      data: requestData,
      method: DEF_CONST.method.POST,
      baseURL: getBaseURL(option, config),
      timeout: getTimeout(option, config),
      headers: config.headers || {},
      withCredentials: true
    })
  }
}

const appInstance = (option, runtime, axiosAdapter) => {
  return async function (url, data, config) {
    if (!runtime.v1 && !runtime.v2) {
      return axiosAdapter(url, data, config)
    }

    const parseData = await convertFormData(data, option, config, runtime)
    if (!parseData) {
      return axiosAdapter(url, data, config)
    }

    const bridge = runtime.v2 ? BRIDGE_METHOD.uploadImageV2 : BRIDGE_METHOD.uploadImage

    debugFn(option, { version: pkg.version, runtime, method: bridge })

    return new Promise((resolve, reject) => {
      biliBridge.callNative({
        method: bridge,
        data: {
          url: convertRequestURL(url, data, DEF_CONST.method.POST, option, config),
          name: parseData.fileKey,
          fileName: parseData.fileName,
          base64Data: parseData.fileValue,
          formData: parseData.dataObj,
          header: config.headers || {}
        },
        callback: (status, message) => {
          if (status !== 'ok') {
            const err = createError(message || status, { option, config, runtime, bridge }, -1, parseData, null)
            reject(err)
          }
        },
        onLoad: ({ httpStatus, response }) => {
          let res
          try {
            res = JSON.parse(response)
          } catch (e) {
            httpStatus = 0
            res = response
          }
          if (httpStatus < 200 || httpStatus >= 400) {
            const err = createError(response, { option, config, runtime, bridge }, httpStatus, parseData, res)
            return reject(err)
          }

          resolve(res)
        }
      })
    })
  }
}

const createUpload = (option, runtime) => {
  const axiosAdapter = webInstance(option, runtime)

  return appInstance(option, runtime, axiosAdapter)
}

export default createUpload
